import PropTypes from 'prop-types';

const STATUS_COLORS = {
    green: '#16a34a',
    yellow: '#f59e0b',
    red: '#dc2626',
    gray: '#94a3b8'
};

export default function ProgressBar({ value, target, status, empty }) {
    const hasValue = !empty && Number.isFinite(Number(value));
    const percent = hasValue
        ? Math.min(target ? (Number(value) / target) * 100 : 0, 100)
        : 0;

    return (
        <div className="progress-wrapper">
            <div className="progress-bar">
                <div
                    className="progress-fill"
                    style={{
                        width: hasValue ? `${percent}%` : '0%',
                        background: STATUS_COLORS[status] || STATUS_COLORS.gray
                    }}
                />
            </div>
            <span className="progress-pct">
                {hasValue ? `${percent.toFixed(0)}%` : '—'}
            </span>
        </div>
    );
}

ProgressBar.propTypes = {
    value: PropTypes.number,
    target: PropTypes.number,
    status: PropTypes.string.isRequired,
    empty: PropTypes.bool
};

ProgressBar.defaultProps = {
    value: null,
    target: undefined,
    empty: false
};
